__turbopack_context__.v({
  "arbArrow": "styles-module-scss-module__-zeSeW__arbArrow",
  "arbMarket": "styles-module-scss-module__-zeSeW__arbMarket",
  "arbPrice": "styles-module-scss-module__-zeSeW__arbPrice",
  "arbSpread": "styles-module-scss-module__-zeSeW__arbSpread",
  "arbSpreadPct": "styles-module-scss-module__-zeSeW__arbSpreadPct",
  "arbitrageTable": "styles-module-scss-module__-zeSeW__arbitrageTable",
  "arbitrageTableWrapper": "styles-module-scss-module__-zeSeW__arbitrageTableWrapper",
  "atlasTitle": "styles-module-scss-module__-zeSeW__atlasTitle",
  "bubbleControls": "styles-module-scss-module__-zeSeW__bubbleControls",
  "bubbleGrid": "styles-module-scss-module__-zeSeW__bubbleGrid",
  "bubblePanel": "styles-module-scss-module__-zeSeW__bubblePanel",
  "bubbleSection": "styles-module-scss-module__-zeSeW__bubbleSection",
  "colLabel": "styles-module-scss-module__-zeSeW__colLabel",
  "ctaBody": "styles-module-scss-module__-zeSeW__ctaBody",
  "ctaButton": "styles-module-scss-module__-zeSeW__ctaButton",
  "ctaEyebrow": "styles-module-scss-module__-zeSeW__ctaEyebrow",
  "ctaSection": "styles-module-scss-module__-zeSeW__ctaSection",
  "featureStory": "styles-module-scss-module__-zeSeW__featureStory",
  "featureStoryContent": "styles-module-scss-module__-zeSeW__featureStoryContent",
  "featureStoryImage": "styles-module-scss-module__-zeSeW__featureStoryImage",
  "featureStoryLink": "styles-module-scss-module__-zeSeW__featureStoryLink",
  "filterSelect": "styles-module-scss-module__-zeSeW__filterSelect",
  "gradientSection": "styles-module-scss-module__-zeSeW__gradientSection",
  "heroHeader": "styles-module-scss-module__-zeSeW__heroHeader",
  "heroPortrait": "styles-module-scss-module__-zeSeW__heroPortrait",
  "hvRank": "styles-module-scss-module__-zeSeW__hvRank",
  "inlineLink": "styles-module-scss-module__-zeSeW__inlineLink",
  "lockedBtn": "styles-module-scss-module__-zeSeW__lockedBtn",
  "lockedCTA": "styles-module-scss-module__-zeSeW__lockedCTA",
  "mapControls": "styles-module-scss-module__-zeSeW__mapControls",
  "mapModeToggle": "styles-module-scss-module__-zeSeW__mapModeToggle",
  "mapSection": "styles-module-scss-module__-zeSeW__mapSection",
  "mapTableGrid": "styles-module-scss-module__-zeSeW__mapTableGrid",
  "mapTablePanel": "styles-module-scss-module__-zeSeW__mapTablePanel",
  "marketIntelHeader": "styles-module-scss-module__-zeSeW__marketIntelHeader",
  "marketIntelSection": "styles-module-scss-module__-zeSeW__marketIntelSection",
  "marketIntelTable": "styles-module-scss-module__-zeSeW__marketIntelTable",
  "miBrand": "styles-module-scss-module__-zeSeW__miBrand",
  "miColTitle": "styles-module-scss-module__-zeSeW__miColTitle",
  "miGrid": "styles-module-scss-module__-zeSeW__miGrid",
  "miNegative": "styles-module-scss-module__-zeSeW__miNegative",
  "miPositive": "styles-module-scss-module__-zeSeW__miPositive",
  "miRank": "styles-module-scss-module__-zeSeW__miRank",
  "miSegmentTabs": "styles-module-scss-module__-zeSeW__miSegmentTabs",
  "miToggle": "styles-module-scss-module__-zeSeW__miToggle",
  "miToggleBtn": "styles-module-scss-module__-zeSeW__miToggleBtn",
  "miToggleBtnActive": "styles-module-scss-module__-zeSeW__miToggleBtnActive",
  "modeBtn": "styles-module-scss-module__-zeSeW__modeBtn",
  "modeBtnActive": "styles-module-scss-module__-zeSeW__modeBtnActive",
  "noDataMessage": "styles-module-scss-module__-zeSeW__noDataMessage",
  "page": "styles-module-scss-module__-zeSeW__page",
  "radarPanelTitle": "styles-module-scss-module__-zeSeW__radarPanelTitle",
  "reportBodySection": "styles-module-scss-module__-zeSeW__reportBodySection",
  "reportParagraph": "styles-module-scss-module__-zeSeW__reportParagraph",
  "reportParagraphCompact": "styles-module-scss-module__-zeSeW__reportParagraphCompact",
  "sectionHeader": "styles-module-scss-module__-zeSeW__sectionHeader",
  "sectionTitle": "styles-module-scss-module__-zeSeW__sectionTitle",
  "sectionTitleDark": "styles-module-scss-module__-zeSeW__sectionTitleDark",
  "sectionTitleDarkSub": "styles-module-scss-module__-zeSeW__sectionTitleDarkSub",
  "sectionTitleItalicSub": "styles-module-scss-module__-zeSeW__sectionTitleItalicSub",
  "sectionTitleSubBlack": "styles-module-scss-module__-zeSeW__sectionTitleSubBlack",
  "tableNote": "styles-module-scss-module__-zeSeW__tableNote",
  "tableNoteDark": "styles-module-scss-module__-zeSeW__tableNoteDark",
  "topVendorsSection": "styles-module-scss-module__-zeSeW__topVendorsSection",
  "vendorCount": "styles-module-scss-module__-zeSeW__vendorCount",
  "vendorName": "styles-module-scss-module__-zeSeW__vendorName",
  "vendorRank": "styles-module-scss-module__-zeSeW__vendorRank",
  "vendorRow": "styles-module-scss-module__-zeSeW__vendorRow",
  "vendorTable": "styles-module-scss-module__-zeSeW__vendorTable",
  "vendorTableCol": "styles-module-scss-module__-zeSeW__vendorTableCol",
  "vendorTableHeader": "styles-module-scss-module__-zeSeW__vendorTableHeader",
  "violinGrid": "styles-module-scss-module__-zeSeW__violinGrid",
  "violinPanel": "styles-module-scss-module__-zeSeW__violinPanel",
  "violinPanelHeader": "styles-module-scss-module__-zeSeW__violinPanelHeader",
  "violinSection": "styles-module-scss-module__-zeSeW__violinSection",
});
